// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Enums =====

import {
    MEDIA_TYPE,
    STORAGE_ENTITY,
    EDITOR_EMBEDDING_TYPE,
}                               from '../enums';

const createMedia = async ({
    test,
    mediaId,
    type,
    postId,
    storageEntity,
    fileName,
    fileExtension,
    url,
    title,
    description,
    caption,
    embeddingType,
    isPostContentDictation,
    dictationSourceText,
    durationMs,
    waveformBars,
}: {
    test: boolean,
    mediaId: string,
    type: MEDIA_TYPE,
    postId?: string,
    storageEntity?: STORAGE_ENTITY,
    fileName?: string,
    fileExtension?: string,
    url?: string,
    title?: string,
    description?: string,
    caption?: string,
    embeddingType?: EDITOR_EMBEDDING_TYPE,
    isPostContentDictation?: boolean,
    dictationSourceText?: string,
    durationMs?: number,
    waveformBars?: number[],
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleCreateMedia = httpsCallable<
        Record<
            string,
            boolean | string | MEDIA_TYPE | EDITOR_EMBEDDING_TYPE | number | number[] | undefined
        >,
        boolean
    >(
        functions,
        'createMedia',
    );
    return handleCreateMedia({
        test,
        postId,
        mediaId,
        type,
        storageEntity,
        fileName,
        fileExtension,
        url,
        title,
        description,
        caption,
        embeddingType,
        isPostContentDictation,
        dictationSourceText,
        durationMs,
        waveformBars,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default createMedia;
